module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Locator-153994228b537d5649f4496a9d7083bb.png";